import { etcRecombinationListState } from "./../recoil/company";
import { useEffect } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  companyCategoryState,
  companyEventListState,
  companyLocationFilterState,
  companyWeddingFilterState,
  recombinationListState,
} from "recoil/company";
import { getCompanyCategoryList, ICompanyCategory } from "store/data/company";
import { communityCategoryState, communityGroupState } from "recoil/community";
import { getCategoryList, getCommunityGroupList } from "store/data/community";
import {
  contructorEventList,
  contructorHallFilter,
  contructorLocationFilter,
} from "store/data/data";
import { getInquiryBoxList } from "pages/InquiryBoxList/InquiryBoxList";

const defaultCompanyCategory: ICompanyCategory[] = [
  { category: "웨딩홀" },
  { category: "스튜디오/스냅" },
  { category: "드레스" },
  { category: "메이크업" },
  { category: "플래닝" },
  { category: "본식스냅" },
  { category: "본식DVD" },
  { category: "제주업체" },
  { category: "예복" },
  { category: "한복" },
  { category: "예물" },
  { category: "피부관리" },
  { category: "허니문" },
  { category: "가전" },
  { category: "가구/매트리스" },
  { category: "기타" },
];

export default function useInitData() {
  const [companyCategory, setCompanyCategory] =
    useRecoilState(companyCategoryState);
  const setCommunityGroup = useSetRecoilState(communityGroupState);
  const setCommunityCategory = useSetRecoilState(communityCategoryState);
  const setCompanyLocation = useSetRecoilState(companyLocationFilterState);
  const setWeddingFilter = useSetRecoilState(companyWeddingFilterState);
  const setCompanyEventList = useSetRecoilState(companyEventListState);
  const [recombinationList, setRecombinationList] = useRecoilState(
    recombinationListState
  );
  const setEtcRecombinationList = useSetRecoilState(etcRecombinationListState);

  async function getCompanyCategory() {
    try {
      const { data, success } = await getCompanyCategoryList();
      if (success) {
        setCompanyCategory(data.result);
      } else {
        throw Error("데이터 없음");
      }
    } catch (error) {
      console.log("getCompanyCategory error", error);
      setCompanyCategory(defaultCompanyCategory);
    }
  }
  async function getCommunityGroup() {
    try {
      const { data, success } = await getCommunityGroupList();
      if (success) {
        setCommunityGroup(data.result);
      }
    } catch (error) {
      console.log("getCommunityGroup error", error);
    }
  }

  async function getCategory() {
    try {
      const { data } = await getCategoryList();
      setCommunityCategory(data.result);
    } catch (error) {
      console.warn("getTags error", error);
    }
  }

  async function getCompanyFilterData() {
    try {
      const { data } = await contructorHallFilter();
      setWeddingFilter(data);
    } catch (error) {
      console.warn("getCompanyFilterData hall error", error);
    }

    try {
      const { data } = await contructorLocationFilter();
      setCompanyLocation(data.result);
    } catch (error) {
      console.warn("getCompanyFilterData location error", error);
    }

    try {
      const { data } = await contructorEventList();
      setCompanyEventList(data);
    } catch (error) {
      console.warn("getCompanyFilterData location error", error);
    }
  }

  async function getInquiryList(type: "wedding" | "etc") {
    try {
      const {
        data: { result },
      } = await getInquiryBoxList({ type });

      const computedList = result.flatMap((item) => {
        if (!item.sublist) return [];

        return item.sublist.map((sub) => {
          const extra_data = [...(item.extra_data || [])];
          const firstPriorityIndex = extra_data.findIndex(
            (data) => data.title === "1순위"
          );

          if (firstPriorityIndex !== -1) {
            const firstPriorityItem = extra_data[firstPriorityIndex];
            const splitContents = (firstPriorityItem.content || "").split(",");
            extra_data.splice(firstPriorityIndex, 1);

            if (splitContents.length > 1) {
              splitContents.forEach((content, index) => {
                if (content.trim() !== "") {
                  extra_data.push({
                    title: `${index + 1}순위`,
                    content,
                    category: "counselingDate",
                  });
                }
              });
            } else {
              extra_data.push(firstPriorityItem);
            }
          }

          return {
            ...sub,
            extra_data,
            extra_data_title: item.extra_data_title || "",
          };
        });
      });
      if (type === "wedding") {
        setRecombinationList(computedList);
      } else {
        setEtcRecombinationList(computedList);
      }
    } catch (error) {
      console.warn("getTags error", error);
    }
  }

  useEffect(() => {
    if (companyCategory.length === 0) {
      getCompanyCategory();
    }
  }, []);

  return {
    getCommunityGroup,
    getCategory,
    getCompanyFilterData,
    getInquiryList,
  };
}
